import React from 'react'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type SiderContentCardProps = React.PropsWithChildren<{
    /**
     * The title content
     */
    title: string
    /**
     * The sub title content
     */
    subtitle?: string

    id?: string
}>

export function SiderContentCard(props: SiderContentCardProps) {
    const { children, title, subtitle, id } = props

    return (
        <Paper sx={{ p: '24px' }} id={id}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Typography variant="h6" sx={{ color: colors.gray900, fontSize: '18px', fontWeight: 500, lineHeight: '24px', mb: '4px' }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="subtitle1" sx={{ color: colors.gray500, fontSize: '14px', lineHeight: '20px' }}>
                            {subtitle}
                        </Typography>
                    )}
                </Grid>
                <Grid item xs={12} md={8}>
                    {children}
                </Grid>
            </Grid>
        </Paper>
    )
}

export default SiderContentCard